import { useMemo } from 'react'

import type { Service } from '@/api/services'
import { useLocalStorage } from '@/hooks'

import { SERVICES_SELECTION_STORAGE_KEY } from './services.constants'
import {
  EMPTY_SERVICES_SELECTION,
  parseStoredServicesSelection,
  resolveServicesSelection,
  ServicesSelection,
} from './services.selection'

export const useServicesSelection = (services: Service[]) => {
  const [stored, setStored] = useLocalStorage<ServicesSelection>(
    SERVICES_SELECTION_STORAGE_KEY,
    EMPTY_SERVICES_SELECTION,
  )

  const selection = useMemo(
    () => resolveServicesSelection({ services, stored: parseStoredServicesSelection(stored) }),
    [services, stored],
  )

  const selectCategory = (category: string) => setStored({ category, serviceId: null, skuId: null })

  const selectService = (serviceId: number) => setStored({ ...selection, serviceId, skuId: null })

  const selectSku = (skuId: number) => setStored({ ...selection, skuId })

  // Note: used after a create, when the new service may live in another category
  const selectServiceIn = (category: string, serviceId: number) =>
    setStored({ category, serviceId, skuId: null })

  return { selectCategory, selection, selectService, selectServiceIn, selectSku }
}
